import { useMutation } from 'react-query';
import { useApiPost } from 'src/api';
import { useBuildVars } from 'src/config';
import { useGetRegion } from 'src/util/getRegion';

export function useParserReprocessBids(request: ReprocessRequest) {
  const buildVars = useBuildVars();
  const region = useGetRegion();
  const apiPost = useApiPost<ReprocessResponse>({
    host: buildVars.VP_PARSING_API_BASE,
  });
  return useMutation(() =>
    apiPost(
      `/system.webapi.parserhub/reprocessBid`,
      request,
      {
        'IM-Region': region,
      },
      { 'IM-Region': region }
    )
  );
}
export function useParserReprocessBidsAudit(request: AuditRequest) {
  const buildVars = useBuildVars();
  const apiPost = useApiPost({
    host: buildVars.VP_API_BASE,
  });
  return useMutation(() =>
    apiPost(
      `/system.webapi.gds/api/v1/GdsCoreApiDeals/BidReprocessAudit`,
      request
    )
  );
}
export interface ReprocessRequest {
  countryCode: string;
  documentIds: string[];
}

export interface ReprocessResponse {
  FailedBids?: string[];
  SuccessBids?: string[];
}

export interface AuditRequest {
  BusinessEntity?: string;
  CompanyCode?: string;
  CountryCode?: string;
  DealNumber?: string;
  Username?: string;
  VendorName?: string;
  VendorProgramName?: string;
}
